var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" CWE-"+_vm._s(_vm.vulnerability.number)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.vulnerability.description)+" ")]),_c('p',[_vm._v("Recommendation")]),_c('p',[_vm._v(_vm._s(_vm.finding.poc.recommendation))])])}
var staticRenderFns = []

export { render, staticRenderFns }